import React from 'react';
import styles from './AuctionTooltipContent.css';

export const AuctionTooltipContent: React.FC = ({ children }) => <div className={styles['cont']}>{children}</div>;
